import { PocTooltip } from 'commons/components/components-wrapper/poc-tooltip.component';

interface TooltipTokenCopiedComponentProps {
    visible: boolean;
}

export const TooltipTokenCopiedComponent: React.FC<TooltipTokenCopiedComponentProps> = ({ visible }) => (
    <PocTooltip
        data-testid="tooltip-token-copied"
        anchor={'tenant-label'}
        strategy="fixed"
        placement="top"
        disableTriggers
        visible={visible}
    >
        {'Token copied'}
    </PocTooltip>
);
